/*
  Release page (templates/page.silk-velvet.liquid): the buy box (sections/release-offer.liquid)
  and the page-wide pieces the release-* sections share: the tier test arm, traffic source,
  carousels, videos, accordions, section views, the sticky bar, the delivery line, and the
  two adds.

  Join add: the homepage tier cards' (sections/hp-tiers.liquid) and the BOF page's add.
  Lines from GET /api/tiers for the tier's key (3_month_connoisseur, 3_month_explorer), the
  same properties (_bundleId, _role, _flatDiscount on gifts, _milestoneProgram,
  _milestoneTier), existing bundles removed by line key first (the cart is never cleared),
  one cart read after the add to repair races, then /checkout. On top of that: the main
  line carries _pdp_first_bottle_variant_id (the release bottle, only while it is in stock;
  backend PdpPinService puts it in box 1 of a Recharge checkout order) and _offer_source;
  every line carries _offerProgram; the cart attributes carry _milestoneProgram,
  _milestoneTier, _offerProgram and _offerTraffic (Recharge copies attributes onto
  renewals, not line properties).

  Member add: the bottle alone through CartBundleAdd.smartAdd (opens the drawer).

  Tier test (both boxes vs Explorer only): PostHog flag in data-flag, variants control and
  explorer-only. QA: ?release_arm=control|explorer-only (never exposed). The arm shown is
  the stored answer from an earlier view, else control until the flag answers; it locks
  once the buy box has come on screen and this page's flags have answered (at most until
  4 s after navigation start, or 1.5 s after the box came on screen if later; a click, a
  mouse press or focus in the box locks at once), and the exposure
  ($feature_flag_called) goes out only for a join view whose arm on screen is PostHog's answer.

  Events: release_* through window.whiskyPosthog (it queues until PostHog is ready), each
  with release, arm, member_state and traffic_source.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-rl-offer]');
  var html = document.documentElement;
  var RELEASE = root ? root.getAttribute('data-release') || 'release' : 'release';
  var FLAG = root ? (root.getAttribute('data-flag') || '').trim() : '';
  var ARMS = ['control', 'explorer-only'];
  var ARM_KEY = 'release_arm_' + RELEASE;
  var EXPOSED_KEY = 'release_exposed_' + RELEASE;
  var TRAFFIC_KEY = 'release_traffic_' + RELEASE;

  function read(store, key) { try { return store.getItem(key); } catch (e) { return null; } }
  function write(store, key, value) {
    try { if (value == null) store.removeItem(key); else store.setItem(key, value); } catch (e) {}
  }
  function param(name) {
    try { return new URLSearchParams(window.location.search || '').get(name); } catch (e) { return null; }
  }

  /* ---------- Traffic source: kept for the session, on every event and on the cart ---------- */
  var traffic = (function () {
    var stored = read(window.sessionStorage, TRAFFIC_KEY);
    var source = param('utm_source');
    var medium = param('utm_medium');
    var campaign = param('utm_campaign');
    var value = null;
    if (source || medium || campaign) {
      value = [source || '-', medium || '-', campaign || '-'].join('/');
    } else if (param('fbclid')) {
      value = 'facebook/paid/-';
    } else if (stored) {
      value = stored;
    } else {
      var host = '';
      try { host = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
      value = host && host !== window.location.hostname ? 'referral/' + host : 'direct';
    }
    // A later view with no tags (an in-site click back here) keeps the first answer.
    if (!stored || source || medium || campaign || param('fbclid')) write(window.sessionStorage, TRAFFIC_KEY, value);
    return value.slice(0, 200);
  })();

  var state = root ? root.getAttribute('data-state') || 'join' : 'join';
  // Review links (?release_view, ?release_stock) work on preview themes only: on the live theme
  // nobody can be shown a sold-out or low-stock page that is not true. ?release_arm stays on
  // live (the Explorer-only link is the ads test's forced variant).
  var onLive = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
  var qaView = onLive ? null : param('release_view');
  var QA_STATES = ['join', 'member', 'sold-out', 'member-sold-out'];
  var reviewOnly = false;
  if (root && qaView && QA_STATES.indexOf(qaView) !== -1 && qaView !== state) {
    // Review only: another state's markup, every button inert, so a review never writes a cart.
    state = qaView;
    reviewOnly = true;
    root.setAttribute('data-state', state);
    root.setAttribute('data-rl-review', 'true');
  }
  var memberState = state === 'member' || state === 'member-sold-out' ? 'member'
    : (root && root.getAttribute('data-signed-in') === 'true' ? 'signed_in_non_member' : 'guest');

  /* ---------- Arm ---------- */
  var qaArm = param('release_arm');
  if (ARMS.indexOf(qaArm) === -1) qaArm = null;
  var storedArm = read(window.localStorage, ARM_KEY);
  if (ARMS.indexOf(storedArm) === -1) storedArm = null;
  var arm = qaArm || (FLAG ? storedArm : null) || 'control';
  var armSource = qaArm ? 'qa' : (FLAG && storedArm ? 'stored' : 'default');
  var armLocked = false;
  var flagValue = null;
  var flagsLoaded = false; // this page's own flags answer, never PostHog's cached copy
  var lockedSource = null; // where the arm on screen came from when it locked
  // Longest wait for this page's flags: until LOCK_FLOOR_MS after navigation start (PostHog's
  // flags answer lands about 1.7 to 3.4 s after it here), and never less than LOCK_WAIT_MS
  // after the buy box came on screen.
  var LOCK_FLOOR_MS = 4000;
  var LOCK_WAIT_MS = 1500;
  var lockPending = false; // the box is on screen, the lock waits for the flags (requestLock)
  var lockTimer = null;

  function context(extra) {
    var props = { release: RELEASE, arm: arm, arm_source: armSource, member_state: memberState, offer_state: state, traffic_source: traffic };
    if (reviewOnly) props.review_view = true;
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
    return props;
  }
  function track(event, extra) {
    var props = context(extra);
    var ph = window.whiskyPosthog;
    if (ph && typeof ph.capture === 'function') { ph.capture(event, props); return; }
    (window.__releaseQueue = window.__releaseQueue || []).push([event, props]);
  }
  window.addEventListener('whisky-posthog-ready', function () {
    var q = window.__releaseQueue || [];
    window.__releaseQueue = [];
    var ph = window.whiskyPosthog;
    if (!ph || typeof ph.capture !== 'function') return;
    q.forEach(function (e) { ph.capture(e[0], e[1]); });
  });

  function applyArm(next, source) {
    if (armLocked || ARMS.indexOf(next) === -1) return;
    arm = next;
    armSource = source;
    html.classList.toggle('rl-arm-explorer-only', arm === 'explorer-only');
    if (typeof window.__releaseOnArm === 'function') window.__releaseOnArm(arm);
  }
  applyArm(arm, armSource);

  // posthog-js may define itself after this file; drain anything queued once it is there.
  var drainTries = 0;
  var drainTimer = setInterval(function () {
    drainTries += 1;
    var ph = window.whiskyPosthog;
    if (ph && typeof ph.capture === 'function') {
      var q = window.__releaseQueue || [];
      window.__releaseQueue = [];
      q.forEach(function (e) { ph.capture(e[0], e[1]); });
    }
    if ((ph && !(window.__releaseQueue || []).length) || drainTries > 100) clearInterval(drainTimer);
  }, 200);

  /* ---------- Flag: read without PostHog's own exposure, expose once for the arm on screen ---------- */
  function rawPosthog() { return typeof window.posthog !== 'undefined' ? window.posthog : null; }
  function readFlag() {
    var ph = rawPosthog();
    try {
      if (ph && typeof ph.getFeatureFlag === 'function') return ph.getFeatureFlag(FLAG, { send_event: false });
    } catch (e) {}
    return undefined;
  }
  function maybeExpose() {
    // Only a join view tests anything: members and sold-out views see no tier choice.
    if (!FLAG || qaArm || reviewOnly || state !== 'join' || !armLocked) return;
    // Only a view whose arm was the flag's (or the stored flag answer) before it locked counts:
    // a default control view that the flag later agrees with is not exposed, so neither arm
    // gains late answers the other cannot.
    if (!flagsLoaded || flagValue !== arm || lockedSource === 'default') return;
    if (read(window.sessionStorage, EXPOSED_KEY) === arm) return;
    var ph = rawPosthog();
    if (!ph || typeof ph.capture !== 'function') return;
    try {
      ph.capture('$feature_flag_called', { $feature_flag: FLAG, $feature_flag_response: arm }, { send_instantly: true });
      write(window.sessionStorage, EXPOSED_KEY, arm);
      track('release_arm_assigned', { exposed: true });
    } catch (e) {}
  }
  function onFlags(loaded) {
    if (!FLAG || qaArm) return;
    var value = readFlag();
    if (loaded) flagsLoaded = true;
    if (ARMS.indexOf(value) === -1) {
      // Flags have arrived and this one is off or gone: control, nobody exposed, no stored arm,
      // and a stored explorer-only arm goes back to both boxes if the arm has not locked yet.
      if (loaded) {
        flagValue = null;
        write(window.localStorage, ARM_KEY, null);
        if (!armLocked && arm !== 'control') applyArm('control', 'default');
      }
    } else {
      flagValue = value;
      write(window.localStorage, ARM_KEY, value);
      if (!armLocked && value !== arm) applyArm(value, 'flag');
      else if (value === arm && armSource !== 'qa') armSource = armSource === 'stored' ? 'stored' : 'flag';
    }
    // The box came on screen while the flags were on their way: lock now, on the flag's arm.
    if (loaded && lockPending) lockArm();
    else maybeExpose();
  }
  if (FLAG && !qaArm) {
    var hookFlags = function () {
      var c = window.whiskyPosthog;
      if (c && typeof c.onFeatureFlags === 'function') {
        // A failed /flags request still calls back, with PostHog's stored copy and
        // { errorsLoading: true }: not this page's answer, and after one only a call with
        // errorsLoading false counts. A handler registered after the request finished is called
        // at once with no third argument, success or failure alike, and that call counts (the
        // request has to finish before this deferred script runs).
        var flagsFailed = false;
        c.onFeatureFlags(function (flags, variants, ctx) {
          if (ctx && ctx.errorsLoading) flagsFailed = true;
          onFlags(ctx ? !ctx.errorsLoading : !flagsFailed);
        });
        onFlags(false);
        return true;
      }
      return false;
    };
    if (!hookFlags()) window.addEventListener('whisky-posthog-ready', hookFlags, { once: true });
  }

  // The buy box can be on screen before PostHog's flags answer (about 2-3 s after load here): the
  // hero CTA's #release-offer jump, a link with that hash, a reload with the scroll kept. Locking
  // then kept those views on the default arm whatever the flag said, so the lock waits for this
  // page's flags answer, at most until 4 s after navigation start or 1.5 s after the box came on
  // screen, whichever is later (PostHog blocked or slow: the arm on screen locks). A click, a
  // mouse press or focus in the buy box, or a join tap, locks at once.
  function requestLock() {
    if (armLocked || lockPending) return;
    if (!FLAG || qaArm || flagsLoaded) { lockArm(); return; }
    lockPending = true;
    var sinceStart = window.performance && typeof performance.now === 'function' ? performance.now() : LOCK_FLOOR_MS;
    lockTimer = setTimeout(lockArm, Math.max(LOCK_WAIT_MS, LOCK_FLOOR_MS - sinceStart));
  }

  function lockArm() {
    if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
    lockPending = false;
    if (armLocked) return;
    armLocked = true;
    lockedSource = armSource;
    track('release_arm_assigned', { exposed: false, flag_value: flagValue });
    maybeExpose();
  }

  /* ---------- Cart requests (the BOF page's helpers: deadlines, two retries on 429 / 5xx) ---------- */
  var apiBase = root ? String(root.getAttribute('data-api-base') || window.__QUIZ_API_BASE__ || '').replace(/\/$/, '') : '';
  var TIER_KEYS = { connoisseur: '3_month_connoisseur', explorer: '3_month_explorer' };
  var MILESTONE_TIER = { connoisseur: '3_month_connoisseur', explorer: 'explorer' };
  var MILESTONE_PROGRAM = '3-month-milestone';
  var REQUEST_TIMEOUT_MS = 12000;
  var ADD_TIMEOUT_MS = 26000;
  var CART_RETRIES = 2;

  function tagError(err, stage, path, httpStatus) {
    if (err && typeof err === 'object') {
      if (stage && !err.stage) err.stage = stage;
      if (path && !err.cart_endpoint) err.cart_endpoint = path;
      if (httpStatus && !err.http_status) err.http_status = httpStatus;
    }
    return err;
  }
  function pause(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function retryAfterMs(res) {
    var h = res && res.headers && res.headers.get ? res.headers.get('Retry-After') : null;
    var n = h ? Number(h) : NaN;
    return Number.isFinite(n) && n > 0 ? Math.min(n * 1000, 8000) : null;
  }
  async function fetchJsonOnce(path, init, stage, reportToken) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT_MS) : null;
    var res;
    try {
      var options = Object.assign({ credentials: 'same-origin' }, init || {});
      if (ctrl) options.signal = ctrl.signal;
      if (reportToken) options.wlReportToken = reportToken;
      res = await fetch(path, options);
    } catch (caught) {
      if (timer) clearTimeout(timer);
      var err = ctrl && ctrl.signal.aborted ? new Error(path + ' timed out after ' + REQUEST_TIMEOUT_MS + 'ms') : caught;
      if (reportToken && err && typeof err === 'object') err._reportToken = reportToken;
      throw tagError(err, stage, path);
    }
    if (timer) clearTimeout(timer);
    if (!res.ok) {
      var e = new Error(path + ' ' + res.status);
      if (reportToken) e._reportToken = reportToken;
      if (res.status === 429) e._retryAfter = retryAfterMs(res);
      throw tagError(e, stage, path, res.status);
    }
    try { return await res.json(); } catch (parseErr) { throw tagError(new Error(path + ' returned no JSON'), stage, path, res.status); }
  }
  async function fetchJson(path, init, stage, reportToken) {
    for (var attempt = 0; ; attempt++) {
      try {
        return await fetchJsonOnce(path, init, stage, reportToken);
      } catch (err) {
        var httpStatus = err && err.http_status;
        var message = err && err.message ? err.message : '';
        var retryable = attempt < CART_RETRIES && (httpStatus === 429 || httpStatus >= 500 || (!httpStatus && !/no JSON|is not set|missing/.test(message)));
        if (!retryable) throw err;
        await pause(err && err._retryAfter ? err._retryAfter : 400 * (attempt + 1));
      }
    }
  }
  function withDeadline(promise, ms, stage, path) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(tagError(new Error(path + ' timed out after ' + ms + 'ms'), stage, path)); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (err) { clearTimeout(t); reject(tagError(err, stage, path)); });
    });
  }
  function postJson(path, body, stage, reportToken) {
    return fetchJson(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }, stage, reportToken);
  }

  function normalizeTierEntry(entry) {
    var e = entry && typeof entry === 'object' ? entry : {};
    return (Array.isArray(e.items) ? e.items : []).map(function (obj) {
      var it = obj && typeof obj === 'object' ? obj : {};
      var variant = typeof it.variant === 'number' && Number.isFinite(it.variant) ? String(Math.trunc(it.variant)) : (typeof it.variant === 'string' ? it.variant.trim() : '');
      var quantity = Number.isFinite(Number(it.quantity)) ? Number(it.quantity) : 0;
      var plan = typeof it.sellingPlan === 'number' && Number.isFinite(it.sellingPlan) ? String(Math.trunc(it.sellingPlan)) : (typeof it.sellingPlan === 'string' ? it.sellingPlan.trim() : '');
      if (!variant || quantity <= 0) return null;
      var item = { id: variant, quantity: quantity };
      if (plan) item.selling_plan = Number(plan) || plan;
      if (it.properties && typeof it.properties === 'object') item.properties = it.properties;
      if (typeof it._role === 'string' && it._role.trim()) item._role = it._role.trim();
      var fd = it.flatDiscount;
      if (fd != null && fd !== '') {
        if (typeof fd === 'number' && Number.isFinite(fd)) item.flatDiscount = fd;
        else if (typeof fd === 'string' && fd.trim()) { var n = Number(fd.trim()); item.flatDiscount = Number.isFinite(n) ? n : fd.trim(); }
      }
      return item;
    }).filter(Boolean);
  }
  async function fetchTierItems(key) {
    if (!apiBase) throw tagError(new Error('Quiz API base URL is not set'), 'tier_fetch', '/api/tiers');
    var json = await fetchJson(apiBase + '/api/tiers', { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'omit' }, 'tier_fetch');
    var tiers = (json && json.data && json.data.tiers) || (json && json.tiers) || null;
    var items = normalizeTierEntry(tiers && tiers[key]);
    if (!items.length) throw tagError(new Error('Tier payload missing ' + key + ' items'), 'tier_fetch', '/api/tiers');
    return items;
  }
  function bundleIdOf(item) {
    var p = item && item.properties;
    return p && typeof p._bundleId === 'string' ? p._bundleId.trim() : '';
  }

  // One box per cart: every bundle already there goes out by line key in one call; the cart
  // is never cleared, unrelated items stay.
  async function removeExistingBundles(reportToken) {
    var cart = await fetchJson('/cart.js', { headers: { Accept: 'application/json' } }, 'cart_verify', reportToken);
    var updates = {};
    var count = 0;
    (Array.isArray(cart && cart.items) ? cart.items : []).forEach(function (item) {
      if (bundleIdOf(item) && item.key) { updates[item.key] = 0; count++; }
    });
    if (count) await postJson('/cart/update.js', { updates: updates }, 'cart_remove_existing', reportToken);
  }

  var offerProgram = root ? (root.getAttribute('data-offer-program') || '').trim() : '';
  var offerSource = root ? (root.getAttribute('data-offer-source') || '').trim() : '';
  var bottleVariant = root ? (root.getAttribute('data-bottle-variant') || '').trim() : '';

  function buildBundle(items, tier, bundleId, pin) {
    return items.map(function (item) {
      var role = item._role || 'main';
      var flatDiscount = item.flatDiscount;
      var rest = Object.assign({}, item);
      delete rest._role;
      delete rest.flatDiscount;
      var p = Object.assign({}, rest.properties || {}, {
        _bundleId: bundleId,
        _role: role,
        _milestoneProgram: MILESTONE_PROGRAM,
        _milestoneTier: MILESTONE_TIER[tier],
      });
      if (offerProgram) p._offerProgram = offerProgram;
      if (role.toLowerCase() === 'gift' && flatDiscount != null && flatDiscount !== '') {
        p._flatDiscount = typeof flatDiscount === 'number' && Number.isFinite(flatDiscount) ? String(flatDiscount) : String(flatDiscount).trim();
      }
      if (role.toLowerCase() === 'main') {
        // Box 1 gets the release bottle (backend PdpPinService, Recharge checkout orders only).
        // The release source rides only with the pin, so a sold-out join never counts as a bottle.
        if (pin && bottleVariant) {
          p._pdp_first_bottle_variant_id = bottleVariant;
          if (offerSource) p._offer_source = offerSource;
        }
      }
      rest.properties = p;
      return rest;
    });
  }
  async function addBundle(bundled, reportToken) {
    if (window.CartBundleAdd && typeof window.CartBundleAdd.smartAdd === 'function') {
      return withDeadline(window.CartBundleAdd.smartAdd(bundled, { reportToken: reportToken }), ADD_TIMEOUT_MS, 'cart_add', '/cart/add.js');
    }
    return postJson('/cart/add.js', { items: bundled }, 'cart_add', reportToken);
  }
  // Recharge carries order attributes onto renewals, not line properties (2026-09-12).
  function setAttributes(tier, reportToken) {
    return postJson('/cart/update.js', { attributes: {
      _milestoneProgram: MILESTONE_PROGRAM,
      _milestoneTier: MILESTONE_TIER[tier],
      _offerProgram: offerProgram,
      _offerTraffic: traffic,
      // A taste profile visit's Starter test arm must not ride onto this order.
      _starterTierTest: '',
    } }, 'cart_attributes', reportToken);
  }
  function bundleTs(id) { var m = /_(\d+)$/.exec(id || ''); return m ? Number(m[1]) : 0; }
  function newerBundle(a, b) { if (b === null) return true; var ta = bundleTs(a), tb = bundleTs(b); return ta > tb || (ta === tb && a > b); }
  // The add is not atomic: of the bundles in the cart the newest stays, every other one goes
  // out by key, a kept main above quantity 1 goes back to 1 (the BOF / Labor Day rule).
  async function recheckBundles(reportToken) {
    var cart = await fetchJson('/cart.js', { headers: { Accept: 'application/json' } }, 'cart_recheck', reportToken);
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var keep = null;
    items.forEach(function (item) { var id = bundleIdOf(item); if (id && newerBundle(id, keep)) keep = id; });
    var updates = {};
    var removed = 0;
    var fixed = 0;
    items.forEach(function (item) {
      var id = bundleIdOf(item);
      if (!id || !item.key) return;
      if (id !== keep) { updates[item.key] = 0; removed++; return; }
      if (item.properties && item.properties._role === 'main' && Number(item.quantity) > 1) { updates[item.key] = 1; fixed++; }
    });
    if (removed || fixed) await postJson('/cart/update.js', { updates: updates }, 'cart_recheck', reportToken);
    return { kept: keep, removed: removed, fixed: fixed };
  }
  function report(err, tier, key, reportToken) {
    var message = err && err.message ? err.message : String(err || 'Unknown cart failure');
    if (!window.WhiskyCartFailure || typeof window.WhiskyCartFailure.report !== 'function') return;
    window.WhiskyCartFailure.report({
      source: 'release_page',
      stage: (err && err.stage) || (window.WhiskyCartFailure.inferStage ? window.WhiskyCartFailure.inferStage(message) : 'unknown'),
      error_message: message,
      http_status: err && err.http_status,
      cart_endpoint: err && err.cart_endpoint,
      _reportToken: (err && err._reportToken) || reportToken,
      tier_key: key,
      tier: tier,
      funnel_mode: key ? 'redirect_checkout' : 'cart_drawer',
    });
  }

  /* ---------- Buy box ---------- */
  if (root) initOffer();

  function initOffer() {
    var status = root.querySelector('[data-rl-status]');
    var errorLine = root.querySelector('[data-rl-error]');
    var options = root.querySelectorAll('[data-rl-option]');
    var mainCta = root.querySelector('[data-rl-cta="main"]');
    var soldoutCta = root.querySelector('[data-rl-cta="soldout-join"]');
    var memberCta = root.querySelector('[data-rl-cta="member-add"]');
    var sticky = root.querySelector('[data-rl-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-rl-cta="sticky"]') : null;
    var stickyLabel = sticky ? sticky.querySelector('[data-rl-sticky-label]') : null;
    var ctaPrefix = root.getAttribute('data-cta-prefix') || '';
    var perShort = root.getAttribute('data-per-short') || '';
    var LOADING_LABEL = root.getAttribute('data-loading-label') || 'Preparing your cart';
    var inFlight = false;

    var missing = root.querySelector('[data-rl-missing]');
    if (missing) track('release_offer_missing', { tiers: missing.getAttribute('data-rl-missing') });

    function say(text) { if (status) status.textContent = text || ''; }
    function showError(err) {
      if (!errorLine) return;
      var message = err && err.message ? String(err.message) : '';
      // Only a sentence written for shoppers (Shopify's 422 text, the connection check line).
      var readable = message && message.charAt(0) !== '/' && /\s/.test(message) && /[.!]$/.test(message) && !/timed out|no JSON|Tier payload|API base|Cart kept bundle|Card shows variant|^\[/.test(message);
      errorLine.textContent = readable ? message : (errorLine.getAttribute('data-rl-error-default') || '');
      errorLine.hidden = !errorLine.textContent;
    }
    function clearError() { if (errorLine) { errorLine.hidden = true; errorLine.textContent = ''; } }

    function selectedOption() {
      var visible = null;
      for (var n = 0; n < options.length; n++) {
        if (options[n].classList.contains('is-selected')) return options[n];
        if (!visible && options[n].offsetParent !== null) visible = options[n];
      }
      return visible || options[0] || null;
    }
    function primaryButton() {
      if (state === 'join') return mainCta;
      if (state === 'sold-out') return soldoutCta;
      if (state === 'member') return memberCta;
      return null;
    }
    function labelOf(btn) {
      var t = btn ? (btn.querySelector('[data-rl-cta-label]') || btn) : null;
      return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function setMainLabel(option) {
      if (!mainCta || !option || mainCta.classList.contains('is-loading')) return;
      var target = mainCta.querySelector('[data-rl-cta-label]');
      if (!target) return;
      target.textContent = '';
      target.appendChild(document.createTextNode(ctaPrefix));
      var dot = document.createElement('span');
      dot.className = 'rl-cta__dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = ' • ';
      target.appendChild(dot);
      target.appendChild(document.createTextNode('$' + (option.getAttribute('data-plan-dollars') || '') + '.' + (option.getAttribute('data-plan-cents') || '00') + perShort));
    }
    function syncSticky() {
      if (!stickyLabel) return;
      var p = primaryButton();
      stickyLabel.textContent = p ? labelOf(p) : '';
    }
    function select(option, source) {
      if (!option || inFlight) return;
      for (var n = 0; n < options.length; n++) {
        var on = options[n] === option;
        options[n].classList.toggle('is-selected', on);
        var input = options[n].querySelector('input[type="radio"]');
        if (input) input.checked = on;
      }
      setMainLabel(option);
      syncSticky();
      if (source !== 'arm' && source !== 'restore') {
        track('release_tier_selected', { tier: option.getAttribute('data-rl-tier'), position: Number(option.getAttribute('data-position')) || null, source: source });
      }
    }
    // The shopper reached into the buy box: the arm stays as it is, so a late flags answer never
    // hides the card they chose or moves the Join button under the pointer. A mouse press locks
    // before its click lands; a touch locks on its click only, because a phone scroll that starts
    // on the box is a pointerdown too and must not lock the default arm.
    root.addEventListener('pointerdown', function (e) { if (e.pointerType && e.pointerType !== 'touch') lockArm(); }, true);
    root.addEventListener('click', lockArm, true);
    root.addEventListener('focusin', lockArm, true);
    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var option = input.closest('[data-rl-option]');
      if (!option || option.classList.contains('is-selected')) return;
      if (inFlight) {
        var keep = selectedOption();
        var keepInput = keep && keep.querySelector('input[type="radio"]');
        if (keepInput) keepInput.checked = true;
        return;
      }
      // Only the selected card is open: keep the tapped card under the finger.
      var topBefore = option.getBoundingClientRect().top;
      select(option, 'card');
      var shift = option.getBoundingClientRect().top - topBefore;
      if (Math.abs(shift) > 1) window.scrollBy(0, shift);
    });
    // Chrome restores a checked radio after Back without a change event.
    (function () {
      var checked = root.querySelector('[data-rl-option] input[type="radio"]:checked');
      var option = checked ? checked.closest('[data-rl-option]') : null;
      if (option && !option.classList.contains('is-selected')) select(option, 'restore');
    })();
    // The Explorer-only arm shows the Explorer card alone, so it must be the selected one.
    window.__releaseOnArm = function (next) {
      if (next !== 'explorer-only') { syncSticky(); return; }
      for (var n = 0; n < options.length; n++) {
        if (options[n].getAttribute('data-rl-tier') === 'explorer') { select(options[n], 'arm'); return; }
      }
    };
    window.__releaseOnArm(arm);
    syncSticky();

    function setLoading(btn, on, label) {
      var target = btn.querySelector('[data-rl-cta-label]') || btn.querySelector('span') || btn;
      if (on && !btn.classList.contains('is-loading')) btn.setAttribute('data-rl-label-html', target.innerHTML);
      if (on) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
        target.textContent = LOADING_LABEL;
        say(LOADING_LABEL); // visually hidden: screen readers only
      } else {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        if (label) target.textContent = label;
        else if (btn.hasAttribute('data-rl-label-html')) target.innerHTML = btn.getAttribute('data-rl-label-html');
        say(label || '');
      }
    }

    // The card's price and plan are read from the product; the cart adds what /api/tiers says.
    // If the two name different lines the tap fails before anything is removed or added.
    function shownPlanDiffers(variantId, planId, items, tier, key) {
      var main = null;
      items.forEach(function (it) { if (!main && (it._role || '').toLowerCase() === 'main') main = it; });
      if (!main) return false;
      var tierVariant = String(main.id || '');
      var tierPlan = main.selling_plan == null ? '' : String(main.selling_plan);
      if (variantId === tierVariant && planId === tierPlan) return false;
      track('release_plan_mismatch', { tier: tier, tier_key: key, shown_variant: variantId, shown_plan: planId, tier_variant: tierVariant, tier_plan: tierPlan });
      return true;
    }

    async function joinAdd(btn, placement) {
      var soldOutJoin = state === 'sold-out';
      var source = soldOutJoin ? soldoutCta : selectedOption();
      var tier = source ? (source.getAttribute('data-rl-tier') || '').trim() : '';
      var key = TIER_KEYS[tier];
      if (!key) { track('release_bundle_add_failed', { tier: tier, stage: 'unknown_tier', placement: placement }); return; }
      var variantId = source.getAttribute('data-variant-id') || '';
      var planId = source.getAttribute('data-selling-plan') || '';
      var pin = !soldOutJoin && root.getAttribute('data-bottle-in-stock') === 'true';
      // A tap from the sticky bar can come before the buy box was on screen: the arm locks here too.
      lockArm();
      var bundleId = key + '_' + Date.now();
      var reportToken = {};
      inFlight = true;
      clearError();
      setLoading(btn, true);
      track('release_cta_clicked', { tier: tier, tier_key: key, placement: placement, bundle_id: bundleId, bottle_pinned: pin });
      try {
        var items = await fetchTierItems(key);
        if (shownPlanDiffers(variantId, planId, items, tier, key)) {
          throw tagError(new Error('Card shows variant ' + variantId + ' on plan ' + planId + '; /api/tiers adds another for ' + key), 'plan_mismatch', '/api/tiers');
        }
        await removeExistingBundles(reportToken);
        window.__TASTE_PROFILE_SUPPRESS_CART_DRAWER__ = true;
        await addBundle(buildBundle(items, tier, bundleId, pin), reportToken);
        var repair;
        try {
          repair = await recheckBundles(reportToken);
        } catch (recheckErr) {
          // The box is in the cart; the read was lost. The event is the record, checkout shows the cart.
          track('release_bundle_recheck_failed', { tier: tier, bundle_id: bundleId, error_message: recheckErr && recheckErr.message ? recheckErr.message : String(recheckErr) });
          repair = { kept: bundleId, removed: 0, fixed: 0, checked: false };
        }
        if (repair.kept !== bundleId) {
          throw tagError(new Error('Cart kept bundle ' + (repair.kept || 'none') + ' instead of ' + bundleId), 'cart_recheck', '/cart.js');
        }
        try {
          await setAttributes(tier, reportToken);
        } catch (attrErr) {
          report(attrErr, tier, key, reportToken);
          track('release_attributes_failed', { tier: tier, bundle_id: bundleId, error_message: attrErr && attrErr.message ? attrErr.message : String(attrErr) });
        }
        track('release_bundle_added', { tier: tier, tier_key: key, placement: placement, bundle_id: bundleId, item_count: items.length, bottle_pinned: pin, duplicates_removed: repair.removed, quantity_fixed: repair.fixed, recheck_ok: repair.checked !== false });
        setTimeout(function () { window.location.assign('/checkout'); }, 250);
      } catch (err) {
        window.__TASTE_PROFILE_SUPPRESS_CART_DRAWER__ = false;
        report(err, tier, key, reportToken);
        track('release_bundle_add_failed', { tier: tier, tier_key: key, placement: placement, bundle_id: bundleId, stage: err && err.stage, error_message: err && err.message ? err.message : String(err) });
        inFlight = false;
        setLoading(btn, false);
        showError(err);
        btn.focus();
      }
    }

    async function memberAdd(btn, placement) {
      if (!bottleVariant) return;
      var reportToken = {};
      inFlight = true;
      clearError();
      setLoading(btn, true);
      track('release_member_add_clicked', { placement: placement });
      var items = [{ id: Number(bottleVariant) || bottleVariant, quantity: 1, properties: offerSource ? { _offer_source: offerSource } : undefined }];
      if (!items[0].properties) delete items[0].properties;
      try {
        if (window.CartBundleAdd && typeof window.CartBundleAdd.smartAdd === 'function') {
          await withDeadline(window.CartBundleAdd.smartAdd(items, { reportToken: reportToken }), ADD_TIMEOUT_MS, 'cart_add', '/cart/add.js');
        } else {
          await postJson('/cart/add.js', { items: items }, 'cart_add', reportToken);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        }
        track('release_member_added', { placement: placement });
        inFlight = false;
        setLoading(btn, false);
      } catch (err) {
        report(err, 'member_bottle', null, reportToken);
        track('release_member_add_failed', { placement: placement, stage: err && err.stage, error_message: err && err.message ? err.message : String(err) });
        inFlight = false;
        setLoading(btn, false);
        showError(err);
        btn.focus();
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-rl-cta]') : null;
      if (!btn || !root.contains(btn)) return;
      var kind = btn.getAttribute('data-rl-cta');
      if (kind === 'rating') {
        var rv = document.getElementById('brewzle-reviews-root');
        var target = rv ? (rv.closest('.shopify-section') || rv) : null;
        track('release_rating_clicked', { found: !!target });
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (kind === 'login') { track('release_login_clicked', {}); return; }
      if (kind !== 'main' && kind !== 'soldout-join' && kind !== 'member-add' && kind !== 'sticky') return;
      e.preventDefault();
      var acting = kind === 'sticky' ? primaryButton() : btn;
      if (!acting || inFlight || acting.disabled) return;
      if (reviewOnly) { say(root.getAttribute('data-review-note') || 'Review view: buttons are off.'); return; }
      var placement = kind === 'sticky' ? 'sticky' : 'buy_box';
      if (acting === memberCta) memberAdd(btn, placement);
      else joinAdd(btn, placement);
    });

    // Back from checkout (bfcache): the button must not stay on the loading label.
    window.addEventListener('pageshow', function () {
      inFlight = false;
      root.querySelectorAll('[data-rl-cta].is-loading').forEach(function (b) { setLoading(b, false); });
      say('');
    });

    /* ---------- Low stock line: the bottle's stock, shown only under the threshold ---------- */
    // The section renders the bottle's Shopify stock. A feed in the Brewzle counter's shape
    // ({ claimed, stockLeft }) replaces the number when it answers (stockLeft is the stock the
    // feed stands behind after sold boxes), and at 0 the page turns sold out.
    var lowLine = root.querySelector('[data-rl-low]');
    function showLeft(left) {
      if (!lowLine || lowLine.getAttribute('data-rl-review') === 'true') return;
      var below = Number(lowLine.getAttribute('data-below')) || 0;
      var num = lowLine.querySelector('[data-rl-low-num]');
      if (num) num.textContent = num.textContent.replace(/\d+/, String(left));
      lowLine.hidden = !(left > 0 && left < below);
    }
    var feed = lowLine ? lowLine.getAttribute('data-feed') : '';
    if (feed) {
      fetch(feed, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('counter feed ' + res.status)); })
        .then(function (json) {
          var d = json && json.data && typeof json.data === 'object' ? json.data : json;
          // Only a real number: Number(null) is 0, which would close the page on a feed that
          // does not know the stock.
          if (!d || typeof d.stockLeft !== 'number') return;
          var stockLeft = d.stockLeft;
          if (!isFinite(stockLeft) || stockLeft < 0 || d.stockScanComplete === false) return;
          showLeft(stockLeft);
          // The feed counts sales; when nothing is left the page stops promising the bottle.
          if (stockLeft <= 0 && !reviewOnly) {
            root.setAttribute('data-bottle-in-stock', 'false');
            if (state === 'join') { state = 'sold-out'; root.setAttribute('data-state', state); }
            else if (state === 'member') { state = 'member-sold-out'; root.setAttribute('data-state', state); }
            syncSticky();
            track('release_feed_sold_out', { stock_left: stockLeft });
          }
        })
        .catch(function () { /* the stock figure is already on screen */ });
    }

    /* ---------- Sticky bar (phones): shown while the state's main button is off screen, off over the footer ---------- */
    var primary = primaryButton();
    if (sticky && primary && 'IntersectionObserver' in window) {
      var inView = { cta: true, footer: false, top: true };
      var shownOnce = false;
      var update = function () {
        // Not over the hero either: the hero has its own button.
        var show = !inView.cta && !inView.footer && !inView.top;
        sticky.classList.toggle('is-shown', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        if (show && !shownOnce) { shownOnce = true; track('release_sticky_shown', {}); }
      };
      var watch = function (el, key) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { inView[key] = entry.isIntersecting; });
          update();
        }).observe(el);
      };
      watch(primary, 'cta');
      var hero = document.querySelector('[data-rl-section="hero"]');
      if (hero) watch(hero, 'top'); else inView.top = false;
      var watchFooter = function () {
        var footer = document.querySelector('footer.wl-footer') || document.querySelector('footer');
        if (footer) watch(footer, 'footer');
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchFooter);
      else watchFooter();
    }

    /* ---------- Delivery: the BOF page's promise (ships 1-2, arrives 5-8 business days after), end moved to a later backend estimate ---------- */
    var deliveryLine = root.querySelector('[data-rl-delivery]');
    var deliveryDate = root.querySelector('[data-rl-delivery-date]');
    var memberLine = root.querySelector('[data-rl-delivery-member]');
    var memberRange = root.querySelector('[data-rl-delivery-range]');
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function formatDay(d) { return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate(); }
    function addBusinessDays(from, n) {
      var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n -= 1; }
      return d;
    }
    function showDelivery(latest) {
      var today = new Date();
      var start = addBusinessDays(today, 6);
      var end = addBusinessDays(today, 10);
      if (latest && latest > end) end = latest;
      var text = formatDay(start) + ' - ' + formatDay(end);
      if (deliveryDate) deliveryDate.textContent = text;
      if (memberRange) memberRange.textContent = text;
      if (deliveryLine) deliveryLine.hidden = false;
      if (memberLine) memberLine.hidden = false;
    }
    if (deliveryDate || memberRange) {
      showDelivery(null);
      if (apiBase) {
        var dctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var dtimer = dctrl ? setTimeout(function () { dctrl.abort(); }, 3000) : null;
        fetch(apiBase + '/api/delivery/estimate', { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'omit', mode: 'cors', cache: 'no-store', signal: dctrl ? dctrl.signal : undefined })
          .then(function (res) { if (!res.ok) throw new Error('delivery ' + res.status); return res.json(); })
          .then(function (json) {
            var data = json && json.data;
            var iso = data && (typeof data.maxDate === 'string' ? data.maxDate : data.minDate);
            var d = typeof iso === 'string' ? new Date(iso + 'T00:00:00') : null;
            if (d && !isNaN(d.getTime())) showDelivery(d);
          })
          .catch(function () { /* the promise's range is already on screen */ })
          .then(function () { if (dtimer) clearTimeout(dtimer); });
      }
    }

    // The arm locks when the buy box first comes on screen and the flags have answered (requestLock).
    if ('IntersectionObserver' in window) {
      var lockObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { requestLock(); lockObs.disconnect(); } });
      });
      lockObs.observe(root);
    } else {
      requestLock();
    }
  }

  /* ---------- Review only: ?release_stock=N shows the hero's low stock line as it would read at N ---------- */
  (function () {
    var forced = onLive ? null : param('release_stock');
    var line = document.querySelector('[data-rl-low]');
    if (!line || forced == null || !/^\d+$/.test(forced)) return;
    var n = Number(forced);
    var below = Number(line.getAttribute('data-below')) || 0;
    var num = line.querySelector('[data-rl-low-num]');
    if (num) num.textContent = num.textContent.replace(/\d+/, String(n));
    line.hidden = !(n > 0 && n < below);
    line.setAttribute('data-rl-review', 'true');
  })();

  /* ---------- Page-wide: hero button, carousels, videos, accordions, section views ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-rl-cta="hero"]') : null;
    if (!a) return;
    track('release_hero_cta_clicked', {});
    var target = document.getElementById('release-offer');
    if (!target) return;
    e.preventDefault();
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
  });

  // A [data-rl-carousel] is a native scroll row (snap) with optional prev / next, dots and a
  // progress fill. Arrows step one item and stop at the ends.
  Array.prototype.forEach.call(document.querySelectorAll('[data-rl-carousel]'), function (car) {
    var track_ = car.querySelector('[data-rl-carousel-track]');
    if (!track_) return;
    var name = car.getAttribute('data-rl-carousel');
    var prev = car.querySelectorAll('[data-rl-carousel-prev]');
    var next = car.querySelectorAll('[data-rl-carousel-next]');
    var dots = car.parentNode ? car.parentNode.querySelectorAll('[data-rl-carousel-dot]') : [];
    var fill = car.querySelector('[data-rl-carousel-fill]');
    var lastIndex = 0;
    function items() { return Array.prototype.slice.call(track_.children); }
    function index() {
      var list = items();
      var left = track_.scrollLeft;
      var best = 0, bestD = Infinity;
      list.forEach(function (li, n) { var d = Math.abs(li.offsetLeft - list[0].offsetLeft - left); if (d < bestD) { bestD = d; best = n; } });
      return best;
    }
    function paint() {
      var max = track_.scrollWidth - track_.clientWidth;
      Array.prototype.forEach.call(prev, function (b) { b.disabled = track_.scrollLeft <= 1; });
      Array.prototype.forEach.call(next, function (b) { b.disabled = track_.scrollLeft >= max - 1; });
      var i = index();
      Array.prototype.forEach.call(dots, function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (fill) {
        var share = track_.scrollWidth ? Math.min(1, track_.clientWidth / track_.scrollWidth) : 1;
        fill.style.width = Math.round(share * 100) + '%';
        fill.style.left = Math.round((1 - share) * (max > 0 ? track_.scrollLeft / max : 0) * 100) + '%';
      }
      if (i !== lastIndex) { lastIndex = i; track('release_carousel_moved', { carousel: name, index: i + 1 }); }
    }
    function go(i) {
      var list = items();
      if (!list.length) return;
      i = Math.max(0, Math.min(list.length - 1, i));
      track_.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
    }
    Array.prototype.forEach.call(prev, function (b) { b.addEventListener('click', function () { go(index() - 1); }); });
    Array.prototype.forEach.call(next, function (b) { b.addEventListener('click', function () { go(index() + 1); }); });
    Array.prototype.forEach.call(dots, function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-rl-carousel-dot')) || 0); }); });
    var raf = 0;
    track_.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; paint(); }); }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  // A clip with no still loads its first frame only when the row comes near the screen, so
  // the videos never compete with the hero on a phone's first load.
  (function () {
    var lazy = document.querySelectorAll('video[data-rl-first-frame]');
    if (!lazy.length) return;
    function wake(v) { if (v.getAttribute('preload') === 'none') { v.setAttribute('preload', 'metadata'); try { v.load(); } catch (e) {} } }
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(lazy, wake); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { wake(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '400px 0px' });
    Array.prototype.forEach.call(lazy, function (v) { io.observe(v); });
  })();

  // Videos play in place on tap; one plays at a time.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-rl-video-play]') : null;
    if (!btn) return;
    var video = btn.parentNode ? btn.parentNode.querySelector('video[data-rl-video]') : null;
    if (!video) return;
    Array.prototype.forEach.call(document.querySelectorAll('video[data-rl-video]'), function (v) {
      if (v !== video && !v.paused) v.pause();
    });
    video.controls = true;
    btn.hidden = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    track('release_video_played', { video: video.getAttribute('data-rl-video') });
  });

  Array.prototype.forEach.call(document.querySelectorAll('details[data-rl-accordion], details[data-rl-faq]'), function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      if (d.hasAttribute('data-rl-faq')) track('release_faq_opened', { question: d.getAttribute('data-rl-faq') });
      else {
        var sec = d.closest('[data-rl-section]');
        track('release_accordion_opened', { accordion: d.getAttribute('data-rl-accordion'), section: sec ? sec.getAttribute('data-rl-section') : null });
      }
    });
  });

  // The reused FAQ is buttons, not details.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.quiz-faq__button') : null;
    if (!b) return;
    // The section flips aria-expanded on the same click; read it after.
    setTimeout(function () {
      if (b.getAttribute('aria-expanded') === 'true') track('release_faq_opened', { question: (b.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) });
    }, 0);
  });

  // One view per section, at half the section or half the screen, whichever is less (a
  // 2,000px buy box never reaches half its own height on a phone).
  if ('IntersectionObserver' in window) {
    var seen = {};
    var viewTargets = Array.prototype.slice.call(document.querySelectorAll('[data-rl-section]'));
    // The reused sections (quiz landing's how-it-works, intro, strip, community and FAQ, the
    // Brewzle reviews) carry no data-rl-section; name them here.
    [['#quiz-how', 'how'], ['.quiz-intro', 'intro'], ['#quiz-icons-strip', 'stats'], ['#quiz-community', 'community'], ['.quiz-faq', 'faq'], ['#brewzle-reviews-root', 'reviews']].forEach(function (pair) {
      var el = document.querySelector(pair[0]);
      if (!el) return;
      if (pair[1] === 'reviews' && el.closest('.shopify-section')) el = el.closest('.shopify-section');
      el.setAttribute('data-rl-view-name', pair[1]);
      viewTargets.push(el);
    });
    var viewObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var nameOf = el.getAttribute('data-rl-section') || el.getAttribute('data-rl-view-name');
        var need = Math.min(entry.boundingClientRect.height, window.innerHeight) / 2;
        if (entry.intersectionRect.height < need || seen[nameOf]) return;
        seen[nameOf] = true;
        track('release_section_viewed', { section: nameOf });
      });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    viewTargets.forEach(function (el) { viewObs.observe(el); });
  }
})();
